import { ref, uploadBytesResumable } from 'firebase/storage';
import { storage } from './config';

export const uploadFileToStorage = (file, path) => {
  const storageRef = ref(storage, path);
  return uploadBytesResumable(storageRef, file);
};
